import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import BlueprintView from "../components/BlueprintView";

export default function PublicBlueprint() {
  const { token } = useParams();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    api.get(`/blueprint/${token}`).then(({ data }) => setData(data)).catch(() => setData(null));
  }, [token]);

  if (data === undefined) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-primary" /></div>;
  if (data === null) return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 celestial">
      <p className="font-serif text-3xl">This blueprint isn't shared.</p>
      <Link to="/" className="text-primary hover:underline">Go to MyNsight</Link>
    </div>
  );

  return (
    <div className="min-h-screen celestial px-6 py-12">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <Link to="/" className="text-2xl font-serif text-primary">My<span className="text-foreground">Nsight</span></Link>
          <Link to="/setup" className="gold-btn px-5 py-2.5 rounded-full text-sm">Build your own</Link>
        </div>
        <p className="overline mb-2">Shared blueprint</p>
        <h1 className="font-serif text-5xl mb-8">A soul, mapped.</h1>
        <BlueprintView data={data} synthesis={data.synthesis} />
      </div>
    </div>
  );
}
